var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasOnboardingV3)?_c('aha-icon',{staticClass:"onboarding__arrow",attrs:{"name":"arrow-tail","width":"23","height":"24","viewBox":"0 0 18 19"},on:{"click":function($event){return _vm.backToOnboardingV3()}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }